import { render, staticRenderFns } from "./skillAndHonorDialog.vue?vue&type=template&id=4a2a9744&scoped=true"
import script from "./skillAndHonorDialog.vue?vue&type=script&lang=js"
export * from "./skillAndHonorDialog.vue?vue&type=script&lang=js"
import style0 from "./skillAndHonorDialog.vue?vue&type=style&index=0&id=4a2a9744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2a9744",
  null
  
)

export default component.exports